import { render } from "./footer.vue?vue&type=template&id=1931b4e0"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=1931b4e0&lang=scss"

import exportComponent from "F:\\duoji\\vue3\\vue3_demo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__